import {
  PlayListPageContent,
  ProfilePageWrapper,
} from '../../components/ProfilePageComponents';

export const PlaylistPage = () => (
  <ProfilePageWrapper>
    <PlayListPageContent />
  </ProfilePageWrapper>
);
